import { useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { IClientVisaBrief } from '@bustickus/models-client';
import { Button, Flex, Select } from 'components';
import { SpoilerCard } from 'shared/components';
import './style.scss';

interface IProps {
  open: boolean;
  visas: IClientVisaBrief[];
  onOpen: () => void;
  onAddClick: (country: IClientVisaBrief) => void;
  onGetVisaClick: () => void;
}

function AddVisaCard(props: IProps) {
  const [visaId, setVisaId] = useState<string>(props.visas.length > 0 ? props.visas[0].id : '');

  const handleAddClick = () => {
    const country = props.visas.find((x) => x.id === visaId);

    if (country != null) {
      props.onAddClick(country);
    }
  };

  return (
    <SpoilerCard
      title='Добавление визы'
      open={props.open}
      onOpenClick={() => props.onOpen()}
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex
          gap={10}
          className='visa-country-selector-EFlW'
        >
          <div className='visa-country-select-XoiO'>
            <Select
              value={visaId}
              onChange={(v) => setVisaId(v)}
            >
              {props.visas.map((x) => (
                <option
                  key={x.id}
                  value={x.id}
                >
                  {x.name}
                </option>
              ))}
            </Select>
          </div>
          <Button
            color='blue'
            className='visa-country-select-btn-TRck'
            disabled={props.visas.length === 0}
            onClick={handleAddClick}
          >
            <Flex
              gap={5}
              alignItems='center'
            >
              <span>Добавить</span>
              <bi.ChevronRight />
            </Flex>
          </Button>
        </Flex>
        <Button
          color='transparent-blue'
          onClick={props.onGetVisaClick}
        >
          Нет визы, но хочу оформить
        </Button>
      </Flex>
    </SpoilerCard>
  );
}

export default AddVisaCard;
